import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";

// THIS IS THE ORIGINAL
// export default function () {
//     const prevButton =
//         '<span class="show-for-sr">Previous slide</span><span><svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 35 65" width="9" height="16" xmlns="http://www.w3.org/2000/svg"><g stroke-width="8" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M3 3l29 29M3 62l29-30"/></g></svg></span>';
//     const nextButton =
//         '<span class="show-for-sr">Next slide</span><span><svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 35 65" width="9" height="16" xmlns="http://www.w3.org/2000/svg"><g stroke-width="8" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M32 3L3 32M32 62L3 32"/></g></svg></span>';

//     document.querySelectorAll(".js-multi-carousel").forEach(function (el) {
//         tns({
//             container: el,
//             controlsPosition: "bottom",
//             nav: true,
//             navPosition: "bottom",
//             items: 1,
//             preventScrollOnTouch: "auto",
//             controls: true,
//             arrowKeys: true,
//             lazyload: true,
//             mouseDrag: true,
//             swipeAngle: false,
//             controlsText: [nextButton, prevButton],
//             responsive: {
//                 640: {
//                     gutter: 30,
//                     items: 2,
//                 },
//                 1024: {
//                     items: 3,
//                 },
//                 1500: {
//                     items: 4,
//                 },
//             },
//         });
//     });

export default function () {
    // Define the custom previous and next buttons with SVG icons
    const prevButton =
        '<span class="show-for-sr">Previous slide</span><span><svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 35 65" width="9" height="16" xmlns="http://www.w3.org/2000/svg"><g stroke-width="8" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M3 3l29 29M3 62l29-30"/></g></svg></span>';
    const nextButton =
        '<span class="show-for-sr">Next slide</span><span><svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 35 65" width="9" height="16" xmlns="http://www.w3.org/2000/svg"><g stroke-width="8" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M32 3L3 32M32 62L3 32"/></g></svg></span>';

    // THIS CODE BLOCK WORKS PERFECTLY ASIDE FROM THE ACTIVE CLASS NOT WORKING PROPERLY.
    // Initialize Tiny Slider for each carousel element
    document.querySelectorAll(".js-multi-carousel").forEach(function (el) {
        const slider = tns({
            container: el,
            items: 1,
            controls: false,
            nav: false, // Disable default nav
            controlsPosition: "bottom",
            navPosition: "bottom",
            preventScrollOnTouch: "auto",
            arrowKeys: true,
            lazyload: true,
            mouseDrag: true,
            swipeAngle: false,
            loop: false,
            controlsText: [prevButton, nextButton], // Use the existing buttons
            responsive: {
                640: { gutter: 30, items: 2 },
                1024: { items: 3 },
                1500: { items: 4 },
            },
            onInit: createCustomPagination, // Call custom pagination on init
        });

        // Create custom pagination elements
        function createCustomPagination(info) {
            const totalSlides = info.slideCount;
            const paginationContainer = document.createElement("div");
            paginationContainer.className = "custom-pagination tns-controls";

            // Create Previous Button using existing SVG icon
            const prevBtn = document.createElement("button");
            prevBtn.innerHTML = prevButton;
            prevBtn.className = "pagination-btn prev";
            prevBtn.disabled = true; // Initially disable if on the first slide
            paginationContainer.appendChild(prevBtn);

            // Create page numbers
            for (let i = 0; i < totalSlides; i++) {
                const pageBtn = document.createElement("button");
                pageBtn.textContent = i + 1;
                pageBtn.className = `pagination-btn page-number ${
                    i === 0 ? "active" : ""
                }`;

                // Add event listener to navigate to specific slide
                pageBtn.addEventListener("click", () => {
                    slider.goTo(i);
                    updatePaginationState(i, totalSlides);
                });

                paginationContainer.appendChild(pageBtn);
            }

            // Create Next Button using existing SVG icon
            const nextBtn = document.createElement("button");
            nextBtn.innerHTML = nextButton;
            nextBtn.className = "pagination-btn next";
            paginationContainer.appendChild(nextBtn);

            // Attach event listeners for previous and next buttons
            prevBtn.addEventListener("click", () => {
                slider.goTo("prev");
                updatePaginationState(slider.getInfo().index, totalSlides);
            });

            nextBtn.addEventListener("click", () => {
                slider.goTo("next");
                updatePaginationState(slider.getInfo().index, totalSlides);
            });

            // Insert the custom pagination container after the carousel
            el.after(paginationContainer);
        }

        // Update the state of pagination buttons based on the current slide
        function updatePaginationState(currentIndex, totalSlides) {
            const buttons = document.querySelectorAll(".page-number");
            buttons.forEach((btn, idx) => {
                btn.classList.toggle("active", idx === currentIndex);
            });

            // Enable or disable prev/next buttons based on current position
            document.querySelector(".prev").disabled = currentIndex === 0;
            document.querySelector(".next").disabled =
                currentIndex === totalSlides - 1;
        }
    });

    document.querySelectorAll(".js-single-carousel").forEach(function (el) {
        tns({
            container: el,
            controlsPosition: "bottom",
            navPosition: "bottom",
            nav: false,
            items: 1,
            preventScrollOnTouch: "auto",
            controls: true,
            arrowKeys: true,
            gutter: 30,
            lazyload: true,
            mouseDrag: true,
            swipeAngle: false,
            controlsText: [nextButton, prevButton],
            responsive: {
                768: {
                    items: 2,
                },
                1200: {
                    items: 3.5,
                },
                1500: {
                    items: 4,
                },
            },
        });
    });

    document
        .querySelectorAll(".js-single-carousel-ownership-cards-2-card")
        .forEach(function (el) {
            tns({
                container: el,
                controlsPosition: "bottom",
                navPosition: "bottom",
                nav: false,
                items: 1,
                preventScrollOnTouch: "auto",
                controls: true,
                arrowKeys: true,
                // gutter: 30,
                lazyload: true,
                mouseDrag: true,
                swipeAngle: false,
                controlsText: [nextButton, prevButton],
                responsive: {
                    1024: {
                        items: 2,
                        controls: false,
                        loop: false,
                    },
                },
            });
        });

    document
        .querySelectorAll(".js-single-carousel-ownership-cards")
        .forEach(function (el) {
            tns({
                container: el,
                controlsPosition: "bottom",
                navPosition: "bottom",
                nav: false,
                items: 1,
                preventScrollOnTouch: "auto",
                controls: true,
                arrowKeys: true,
                // gutter: 30,
                lazyload: true,
                mouseDrag: true,
                swipeAngle: false,
                controlsText: [nextButton, prevButton],
                responsive: {
                    1024: {
                        items: 3,
                        controls: true,
                        loop: false,
                    },
                },
            });
        });

    document
        .querySelectorAll(".js-single-carousel-fixed")
        .forEach(function (el) {
            tns({
                container: el,
                controlsPosition: "bottom",
                navPosition: "bottom",
                nav: false,
                items: 1,
                loop: true,
                preventScrollOnTouch: "auto",
                controls: true,
                arrowKeys: true,
                gutter: 15,
                lazyload: true,
                mouseDrag: true,
                swipeAngle: false,
                controlsText: [nextButton, prevButton],
                responsive: {
                    768: {
                        gutter: 30,
                    },
                    1024: {
                        controls: false,
                        loop: false,
                        items: 3,
                    },
                },
            });
        });

    document.querySelectorAll(".js-box-carousel").forEach(function (el) {
        const slider = tns({
            container: el,
            controls: false,
            controlsPosition: "bottom",
            controlsText: [nextButton, prevButton],
            nav: false,
            navPosition: "bottom",
            items: 1,
            preventScrollOnTouch: "auto",
            arrowKeys: true,
            gutter: 0,
            lazyload: false,
            mouseDrag: true,
            swipeAngle: false,
            loop: false,
            responsive: {
                1024: {
                    // gutter: 50,
                    items: 1,
                },
                1366: {
                    // gutter: 50,
                    items: 3,
                },
            },
            onInit: createCustomPagination, // Call custom pagination on init
        });

        // Create custom pagination elements
        function createCustomPagination(info) {
            const totalSlides = info.slideCount;
            const paginationContainer = document.createElement("div");
            paginationContainer.className = "custom-pagination tns-controls";

            // Create Previous Button using existing SVG icon
            const prevBtn = document.createElement("button");
            prevBtn.innerHTML = prevButton;
            prevBtn.className = "pagination-btn prev";
            prevBtn.disabled = true; // Initially disable if on the first slide
            paginationContainer.appendChild(prevBtn);

            // Create page numbers
            for (let i = 0; i < totalSlides; i++) {
                const pageBtn = document.createElement("button");
                pageBtn.textContent = i + 1;
                pageBtn.className = `pagination-btn page-number ${
                    i === 0 ? "active" : ""
                }`;

                // Add event listener to navigate to specific slide
                pageBtn.addEventListener("click", () => {
                    slider.goTo(i);
                    updatePaginationState(i, totalSlides);
                });

                paginationContainer.appendChild(pageBtn);
            }

            // Create Next Button using existing SVG icon
            const nextBtn = document.createElement("button");
            nextBtn.innerHTML = nextButton;
            nextBtn.className = "pagination-btn next";
            paginationContainer.appendChild(nextBtn);

            // Attach event listeners for previous and next buttons
            prevBtn.addEventListener("click", () => {
                slider.goTo("prev");
                updatePaginationState(slider.getInfo().index, totalSlides);
            });

            nextBtn.addEventListener("click", () => {
                slider.goTo("next");
                updatePaginationState(slider.getInfo().index, totalSlides);
            });

            // Insert the custom pagination container after the carousel
            el.after(paginationContainer);
        }

        // Update the state of pagination buttons based on the current slide
        function updatePaginationState(currentIndex, totalSlides) {
            const buttons = document.querySelectorAll(".page-number");
            buttons.forEach((btn, idx) => {
                btn.classList.toggle("active", idx === currentIndex);
            });

            // Enable or disable prev/next buttons based on current position
            document.querySelector(".prev").disabled = currentIndex === 0;
            document.querySelector(".next").disabled =
                currentIndex === totalSlides - 1;
        }
    });

    document.querySelectorAll(".js-box-carousel-narrow").forEach(function (el) {
        tns({
            container: el,
            controlsPosition: "bottom",
            navPosition: "bottom",
            items: 1,
            preventScrollOnTouch: "auto",
            controls: false,
            arrowKeys: true,
            gutter: 0,
            lazyload: false,
            mouseDrag: true,
            swipeAngle: false,
            loop: false,
            responsive: {
                700: {
                    gutter: 50,
                    items: 2,
                },
            },
        });
    });

    document.querySelectorAll(".js-box-carousel-alt").forEach(function (el) {
        tns({
            container: el,
            controlsPosition: "bottom",
            navPosition: "bottom",
            nav: false,
            items: 1.2,
            preventScrollOnTouch: "auto",
            controls: false,
            arrowKeys: true,
            gutter: 0,
            lazyload: false,
            mouseDrag: true,
            swipeAngle: false,
            loop: true,
            responsive: {
                475: {
                    items: 1.5,
                },
                600: {
                    items: 2.15,
                },
                768: {
                    // gutter: 0,
                    items: 2.35,
                },
                900: {
                    items: 2.85,
                },
                1024: {
                    items: 3.35,
                },
                1366: {
                    // gutter: 0,
                    items: 3.75,
                },
                1500: {
                    // gutter: 0,
                    items: 4,
                },
            },
        });
    });

    document
        .querySelectorAll(".js-box-carousel-ownership")
        .forEach(function (el) {
            tns({
                container: el,
                controlsPosition: "bottom",
                navPosition: "bottom",
                nav: false,
                items: 1.2,
                preventScrollOnTouch: "auto",
                controls: false,
                arrowKeys: true,
                gutter: 0,
                lazyload: false,
                mouseDrag: true,
                swipeAngle: false,
                loop: true,
                responsive: {
                    768: {
                        gutter: 0,
                        items: 2,
                    },
                    1366: {
                        gutter: 0,
                        items: 2.9,
                    },
                    1500: {
                        gutter: 0,
                        items: 3,
                    },
                },
            });
        });

    function initInstagramFeed() {
        document.querySelectorAll(".instagram-feed").forEach(function (self) {
            tns({
                container: self,
                gutter: 20,
                items: 1.5,
                controls: false,
                nav: false,
                mouseDrag: true,
                autoplay: true,
                speed: 1500,
                responsive: {
                    768: {
                        items: 2.5,
                        gutter: 20,
                    },
                    992: {
                        items: 2.5,
                    },
                    1200: {
                        items: 3.5,
                    },
                    1600: {
                        items: 4.5,
                    },
                },
            });
        });
    }

    initInstagramFeed();
}

// /* eslint-disable func-names */
// import {
//     tns,
// } from '../../node_modules/tiny-slider/src/tiny-slider';

// const prevButton = '<span class="show-for-sr">Previous slide</span><span><svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 35 65" width="9" height="16" xmlns="http://www.w3.org/2000/svg"><g stroke-width="8" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M3 3l29 29M3 62l29-30"/></g></svg></span>';
// const nextButton = '<span class="show-for-sr">Next slide</span><span><svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 35 65" width="9" height="16" xmlns="http://www.w3.org/2000/svg"><g stroke-width="8" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M32 3L3 32M32 62L3 32"/></g></svg></span>';

// [].forEach.call(document.querySelectorAll('.js-multi-carousel'), function(el) {

//     tns({
//         container: el,
//         controlsPosition: 'bottom',
//         navPosition: 'bottom',
//         items: 1,
//         preventScrollOnTouch: 'auto',
//         controls: false,
//         arrowKeys: true,
//         lazyload: true,
//         mouseDrag: true,
//         swipeAngle: false,
//         controlsText: [
//             nextButton,
//             prevButton,
//         ],
//         responsive: {
//             640: {
//                 gutter: 30,
//                 items: 2,
//                 controls: true,
//             },
//             1200: {
//                 items: 3,
//             },
//         },
//     });

// });

// [].forEach.call(document.querySelectorAll('.js-single-carousel'), function(el) {

//     tns({
//         container: el,
//         controlsPosition: 'bottom',
//         navPosition: 'bottom',
//         items: 3,
//         preventScrollOnTouch: 'auto',
//         controls: false,
//         arrowKeys: true,
//         gutter: 15,
//         lazyload: true,
//         mouseDrag: true,
//         swipeAngle: false,
//         controlsText: [
//             nextButton,
//             prevButton,
//         ],
//         responsive: {
//             800: {
//                 controls: true,
//                 gutter: 20,
//             },
//         },
//     });

// });

// [].forEach.call(document.querySelectorAll('.js-box-carousel'), function(el) {

//     tns({
//         container: el,
//         controlsPosition: 'bottom',
//         navPosition: 'bottom',
//         items: 1,
//         preventScrollOnTouch: 'auto',
//         controls: false,
//         arrowKeys: true,
//         gutter: 0,
//         lazyload: false,
//         mouseDrag: true,
//         swipeAngle: false,
//         loop: false,
//         responsive: {
//             900: {
//                 gutter: 50,
//                 items: 2,
//             },
//             1200: {
//                 gutter: 50,
//                 items: 3,
//             },
//         },
//     });

// });

// [].forEach.call(document.querySelectorAll('.js-box-carousel-narrow'), function(el) {

//     tns({
//         container: el,
//         controlsPosition: 'bottom',
//         navPosition: 'bottom',
//         items: 1,
//         preventScrollOnTouch: 'auto',
//         controls: false,
//         arrowKeys: true,
//         gutter: 0,
//         lazyload: false,
//         mouseDrag: true,
//         swipeAngle: false,
//         loop: false,
//         responsive: {
//             700: {
//                 gutter: 50,
//                 items: 2,
//             },
//         },
//     });

// });

// [].forEach.call(document.querySelectorAll('.js-box-carousel-alt'), function(el) {

//     tns({
//         container: el,
//         controlsPosition: 'bottom',
//         navPosition: 'bottom',
//         items: 1,
//         preventScrollOnTouch: 'auto',
//         controls: false,
//         arrowKeys: true,
//         gutter: 0,
//         lazyload: false,
//         mouseDrag: true,
//         swipeAngle: false,
//         loop: false,
//         responsive: {
//             900: {
//                 gutter: 50,
//                 items: 2,
//             },
//             1200: {
//                 gutter: 50,
//                 items: 3,
//             },
//             1500: {
//                 gutter: 50,
//                 items: 4,
//             },
//         },
//     });

// });

// /**
//  * Instagram feed
//  */
// function initInstagramFeed() {

//     $('.instagram-feed').each(function() {

//         const self = $(this);
//         // init slider
//         tns({
//             container: self[0],
//             gutter: 20,
//             items: 1.5,
//             controls: false,
//             nav: false,
//             mouseDrag: true,
//             autoplay: true,
//             speed: 1500,
//             responsive: {
//                 768: {
//                     items: 2.5,
//                     gutter: 20,
//                 },
//                 992: {
//                     items: 2.5,
//                 },
//                 1200: {
//                     items: 3.5,
//                 },
//                 1600: {
//                     items: 4.5,
//                 },
//             },
//         });

//     });

// }

// initInstagramFeed();
